import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Link } from "react-router-dom";
import saadPortrait from "../../assets/portraits/saad-portrait.jpg";
import "./home.css";

const ROLES = [
  "Full-stack systems",
  "Web platforms",
  "Machine learning & AI",
  "Signal processing",
  "Distributed systems",
  "Simulation & modeling",
];

const ease = [0.23, 1, 0.32, 1] as const;

const RoleIsland = () => {
  const [index, setIndex] = useState(0);
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % ROLES.length);
    }, 2600);
    return () => clearInterval(id);
  }, []);

  return (
    <span className="role-island" aria-live="polite">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.span
          key={index}
          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: -14 }}
          transition={{ duration: 0.4, ease }}
          className="whitespace-nowrap"
        >
          {ROLES[index]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};

const Home = () => {
  return (
    <section id="Home" className="home-section home-hero">
      <div className="home-section-inner">
        <div className="home-hero-grid">
          <div className="home-hero-copy">
            <h1 className="home-hero-title">
              <motion.div
                initial={{ opacity: 0, y: 28 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease }}
              >
                Saad
              </motion.div>
              <motion.div
                initial={{ opacity: 0, y: 28 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.08, ease }}
              >
                Zubairi
              </motion.div>
            </h1>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.35, ease }}
              className="home-hero-role"
            >
              Software engineer. <RoleIsland />
            </motion.p>
          </div>

          <motion.figure
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease }}
            className="home-hero-portrait"
          >
            <img
              src={saadPortrait}
              alt="Black and white portrait of Saad Zubairi"
              loading="eager"
            />
          </motion.figure>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.45, ease }}
          className="home-hero-foot"
        >
          <div className="home-action-row">
            <Link to="/portfolio" className="home-action home-action-primary">
              View my work
              <ArrowRight />
            </Link>
            <a
              href="/SaadZ.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="home-action"
            >
              Resume
              <ArrowUpRight />
            </a>
            <a href="/#Contact" className="home-action">
              Contact
            </a>
          </div>

          <p className="home-hero-lede">
            Founding engineer at Prognosis, building clinical trial supply-chain
            forecasting. MS in Computer Engineering from NYU Tandon. Based in New York.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Home;
